import { MutationOptions, useMutation } from 'react-query';

import BlobFile from '@app/store/documents/BlobFile';
import SampleFile from '@app/store/documents/SampleFile';
import UploadFile from '@app/store/documents/UploadFile';
import { getFileFromURL } from '@app/store/transport-layer/files';
import { documentUpload } from '@app/store/transport-layer/upload/document/upload';

interface UploadDocumentFileReturnType {
  fileId: string;
  isThirdParty: boolean;
  pdfArrayBuffer: ArrayBuffer;
  title: string;
  url: string;
}

export type UploadDocumentFile = File | UploadFile | SampleFile | BlobFile;
/**
 *
 */
export default function useUploadDocumentFile(
  options?: MutationOptions<UploadDocumentFileReturnType, Error, UploadDocumentFile>
) {
  return useMutation<UploadDocumentFileReturnType, Error, UploadDocumentFile>(
    async (file: UploadDocumentFile) => {
      // 문서 파일 업로드
      const { isThirdParty, fileId, title, url } = await documentUpload(file);

      // pdf 다운로드
      const { data: pdfArrayBuffer } = await getFileFromURL(url);

      return {
        fileId,
        isThirdParty,
        pdfArrayBuffer,
        title,
        url,
      };
    },
    options
  );
}
